import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IPluMenuState } from '../../interfaces/states/IPluMenuState';
import { IProductDisplayMenu } from '../../interfaces/dtos/IProductDisplayMenu';
import { ConsumableGroup } from 'src/common/interfaces/dtos/ConsumableGroup';

const initialState: IPluMenuState = {
  consumableGroup: {},
  productDisplayMenus: [],
};

class PluMenuReducer extends ImmerReducer<IPluMenuState> {
  public setPluMenu(consumableGroup: ConsumableGroup) {
    this.draftState.consumableGroup = consumableGroup;
  }

  public setProductDisplayMenus(productDisplayMenus: IProductDisplayMenu[]) {
    this.draftState.productDisplayMenus = productDisplayMenus;
  }
}

export const PluMenuActions = createActionCreators(PluMenuReducer);
export const PluMenuReducerFunction = createReducerFunction(PluMenuReducer, initialState);
